var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.88 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.73.67a2.4,2.4,0,0,0-3.34,0L.68,12.43a2.41,2.41,0,0,0,0,3.36,2.39,2.39,0,0,0,1.64.68,2.3,2.3,0,0,0,1.62-.7L11.59,8.1V55.3a2.39,2.39,0,0,0,4.78,0V8.1L24,15.74a2.36,2.36,0,0,0,1.68.71h0A2.4,2.4,0,0,0,28,14a2.45,2.45,0,0,0-.66-1.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2,59.21a2.35,2.35,0,0,0-1.64-.68,2.28,2.28,0,0,0-1.62.7l-7.65,7.66V19.7a2.39,2.39,0,1,0-4.78,0V66.89l-7.6-7.63a2.36,2.36,0,0,0-1.68-.71h0A2.4,2.4,0,0,0,28.87,61a2.42,2.42,0,0,0,.66,1.59L41.15,74.33a2.42,2.42,0,0,0,1.66.67,2.45,2.45,0,0,0,1.68-.68L56.2,62.57A2.43,2.43,0,0,0,56.2,59.21Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSwitch);
export default __webpack_public_path__ + "static/media/arrow-switch.9b190911.svg";
export { ForwardRef as ReactComponent };